export const onResize = (
  setIsTabletView: (isTablet: boolean) => void,
): (() => void) => {
  function updateSize() {
    setIsTabletView(window.innerWidth < 1280);
  }
  window.addEventListener('resize', updateSize);
  updateSize();

  return () => window.removeEventListener('resize', updateSize);
};
